import CONSTANTS from '../CONSTANTS';

const initialState = {
  assets: {},
  studyTypes: {},
  types: {},
  availableAssets: {},
  search: "",
  assetEdit: {},
  stateMachine: {},
  brands: []
};

const assetsReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONSTANTS.ASSETS_SET_LIST:
      return { ...state, assets: action.assets };
    case CONSTANTS.ASSETS_SET_AVAILABLE :
      return { ...state, availableAssets: action.assets };
    case CONSTANTS.ASSETS_SET_EDIT:
      return { ...state, assetEdit: action.asset };

    case CONSTANTS.ASSETS_UPDATE_LOCAL_ASSET: {

      //get list of asset IDs only
      let assetIdList = state.assets.data.map(a => a._id);
      let newAssetList = [...state.assets.data];
      const assetIndex = assetIdList.indexOf(action.asset);

      if (assetIndex > -1) {
        newAssetList[assetIndex].status = action.status;
      }

      return {...state, assets: {...state.assets, data: [...newAssetList]}};
    }

    case CONSTANTS.ASSETS_SET_TYPES:
      return { ...state, types: action.types };

    case CONSTANTS.ASSETS_SET_STUDY_TYPES:
      return { ...state, studyTypes: action.types };

    case CONSTANTS.ASSETS_SET_STATE_MACHINE: 
      return { ...state, stateMachine: action.machine };

    case CONSTANTS.ASSETS_SET_BRANDS: 
      return { ...state, brands: action.brands };
      
    default:
      return state;
  }
};

export default assetsReducer;